(function (upp) {
    'use strict';

    upp.config(['$routeProvider',
        function ($routeProvider) {
            $routeProvider
                .when('/notifications', {
                    templateUrl: require('../templates/notifications.html'),
                });
        }]);

})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/notifications/routes/notifications-routes.js